/****************************************************
 * Module Name:  labApproveReject.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip, Stack, Typography } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import LabTestProxy from "../../utility/proxy/manager/labTestProxy";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ApproveModal from "./approveModal";
import StoneDetailModal from "../common/stoneDetailModal";
import Constants from "../../utility/constants";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import CommonStoneSelection from "../common/commonStoneSelection";
import VideoLibraryTwoToneIcon from '@mui/icons-material/VideoLibraryTwoTone';
import ExportToExcel from "../common/exportToExcel";
import StoneMediaModal from "../common/stoneMediaModal";
import { LoadingButton } from "@mui/lab";
import NivodaUtilityProxy from "../../utility/proxy/nivodautility/nivodautilityProxy";
import MixStoneBucketModal from "./mixStoneBucketModal";
import PageTitle from "../common/pageTitle";

const LabApproveReject = () => {
  const [listData, setListData] = useState([]);
  const [symMasterMap, setSymMasterMap] = useState([]);
  const [polMasterMap, setPolMasterMap] = useState([]);
  const [floMasterMap, setFloMasterMap] = useState([]);
  const [cutMasterMap, setCutMasterMap] = useState([]);
  const [clarityMasterMap, setClarityMasterMap] = useState([]);
  const [colorMasterMap, setColorMasterMap] = useState([]);
  const [flag, setFlag] = useState(false);

  const [approveRejectListLoader, setApproveRejectListLoader] = useState(false);

  const [selectionModel, setSelectionModel] = useState([]);

  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [successResponse, setSuccessResponse] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [type, setType] = useState("");

  const [stoneId, setStoneId] = useState("");
  const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
  const [columnNames, setColumnNames] = React.useState([]);

  const [stoneMediaURL, setStoneMediaURL] = useState([]);
  const [showStoneMediaModal, setShowStoneMediaModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [fullExcelData, setFullExcelData] = useState({});

  // eslint-disable-next-line
  const [local_Permission, setLocal_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.OPERATION_LAB_APPROVEREJECT
    )
  );

  //top most summary table 
  const [noOfSelectedStones, setNoOfSelectedStones] = useState("0");
  const [selectedTotalSize, setSelectedTotalSize] = useState("0");
  const [selectedAvgDiscount, setSelectedAvgDiscount] = useState("0");
  const [selectedavgPrice, setSelectedavgPrice] = useState("0");
  const [selectedtotalPrice, setSelectedtotalPrice] = useState("0");

  useEffect(() => {
    PageTitle("OPERATION_LAB_APPROVEREJECT");
    handleSearchSym();
    handleSearchPol();
    handleSearchFlo();
    handleSearchCut();
    handleSearchClarity();
    handleSearchColor();

  }, []);

  useEffect(() => {
    if (flag)
      handleSearch();
  }, [flag])

  const loadTotalData = (data) => {
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size

    data.forEach((iData) => {
      let pricePerCarat = iData.price
      totalSize += iData.size;
      totalPrice += (iData.size * pricePerCarat);
      total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));

    });
    setNoOfSelectedStones(data.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
  };

  useEffect(() => {
    if (selectionModel.length <= 0) {
      loadTotalData(listData);
      return;
    }
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size
    listData.forEach((iData) => {
      if (selectionModel.includes(iData.stoneid)) {
        let pricePerCarat = iData.price
        totalSize += iData.size;
        totalPrice += (iData.size * pricePerCarat);
        total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
      }
    });
    setNoOfSelectedStones(selectionModel.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );

  }, [selectionModel]);

  useEffect(() => {
    if (selectionModel && selectionModel.length > 0) {
      const filteredData = listData.filter((data) =>
        selectionModel.includes(data.stoneid)
      );
      setFullExcelData(getExcelData(filteredData));
    } else {
      setFullExcelData(getExcelData(listData));
    }
  }, [selectionModel, listData]);

  const handleSearch = () => {
    setApproveRejectListLoader(true);
    LabTestProxy.GetAllApproveRejectStones((response) => {
      if (response) {

        const uniqueFilterValues = {
          labshape: Utility.getDistinctOptions(response, 'labshape'),
        }

        prepareColumns(uniqueFilterValues);
        setListData(response);
        loadTotalData(response);
        setApproveRejectListLoader(false);
        setLoading(false);
        setRejectLoading(false);
      } else {
        setErrorSnackbar(true)
        setApproveRejectListLoader(false);
      }
    });
  };

  const prepareColumns = (uniqueFilterValues) => {
    let columnNames = [];

    columnNames.push({
      field: "id",
      headerName: "BATCH ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
    });

    Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
      if (columnsData.hasOwnProperty(iColPermission)) {
        const columnData = columnsData[iColPermission];
        columnNames.push(columnData);
        if (columnData.field === "stoneid") {
          columnNames.push({
            field: "suratid",
            headerName: "SURATID",
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "text",
            renderCell: renderCellExpand,
          });
        }
        if (columnData.field === "mf_shape") {
          columnNames.push(
            {
              field: "labshape",
              headerName: "LAB SHAPE",
              headerAlign: "center",
              align: "center",
              valueOptions: uniqueFilterValues ? uniqueFilterValues.labshape : [],
              type: "singleSelect",
              filterOperators: Utility.combinedFilters(),
              width: 90,
              renderCell: renderCellExpand,
            }
          )
        }
        if (columnData.field === "mf_size") {
          columnNames.push({
            field: "size",
            headerName: "SIZE",
            headerAlign: "center",
            align: "right",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 40,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size),
            cellClassName: (params) => {
              return (params.row.size === null || params.row.mf_size === null) ? undefined : (params.row.mf_size === params.row.size) ? null : (params.row.mf_size > params.row.size) ? 'yellowCell' : 'greenCell';
            }
          })
        }
        else if (columnData.field === "mf_color") {
          columnNames.push({
            field: "color",
            headerName: "COLOR",
            headerAlign: "center",
            align: "center",
            width: 65,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            cellClassName: (params) => {
              return (params.row.color === null || params.row.mf_color === null) ? undefined : (colorMasterMap[params.row.mf_color[0]] === colorMasterMap[params.row.color[0]]) ? null : (colorMasterMap[params.row.mf_color[0]] < colorMasterMap[params.row.color[0]]) ? 'yellowCell' : 'greenCell';
            }
          })
        }
        else if (columnData.field === "mf_clarity") {
          columnNames.push({
            field: "clarity",
            headerName: "CLARITY",
            headerAlign: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            align: "center",
            width: 75,
            renderCell: renderCellExpand,
            cellClassName: (params) => {
              return (params.row.clarity === null && params.row.mf_clarity != null) ? 'yellowCell' : clarityMasterMap[params.row.mf_clarity] === clarityMasterMap[params.row.clarity] ? null : clarityMasterMap[params.row.mf_clarity] < clarityMasterMap[params.row.clarity] ? 'yellowCell' : 'greenCell';
            }
          })
        }
        else if (columnData.field === "mf_cut") {
          columnNames.push({
            field: "cut",
            headerName: "CUT",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            width: 50,
            renderCell: renderCellExpand,
            cellClassName: (params) => {
              return (params.row.cut === null && params.row.mf_cut != null) ? 'yellowCell' : cutMasterMap[params.row.mf_cut] === cutMasterMap[params.row.cut] ? null : cutMasterMap[params.row.mf_cut] < cutMasterMap[params.row.cut] ? 'yellowCell' : 'greenCell';
            }
          })
        }
        else if (columnData.field === "mf_pol") {
          columnNames.push({
            field: "pol",
            headerName: "POL",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            cellClassName: (params) => {
              return (params.row.pol === null && params.row.mf_pol != null) ? 'yellowCell' : polMasterMap[params.row.mf_pol] === polMasterMap[params.row.pol] ? null : polMasterMap[params.row.mf_pol] < polMasterMap[params.row.pol] ? 'yellowCell' : 'greenCell';
            }
          })
        }

        else if (columnData.field === "mf_sym") {
          columnNames.push({
            field: "sym",
            headerName: "SYM",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            cellClassName: (params) => {
              return (params.row.sym === null && params.row.mf_sym != null) ? 'yellowCell' : symMasterMap[params.row.mf_sym] === symMasterMap[params.row.sym] ? null : symMasterMap[params.row.mf_sym] < symMasterMap[params.row.sym] ? 'yellowCell' : 'greenCell';
            }
          })
        }
        else if (columnData.field === "mf_flo") {
          columnNames.push({
            field: "flo",
            headerName: "FLO",
            headerAlign: "center",
            align: "center",
            width: 60,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
            cellClassName: (params) => {
              return (params.row.flo === null && params.row.mf_flo != null) ? 'yellowCell' : floMasterMap[params.row.mf_flo] === floMasterMap[params.row.flo] ? null : floMasterMap[params.row.mf_flo] < floMasterMap[params.row.flo] ? 'yellowCell' : 'greenCell';
            }
          })
        }
        else if (columnData.field === "mf_colordescription") {
          columnNames.push({
            field: "colordescriptions",
            headerName: "COL DESCRIP",
            headerAlign: "center",
            align: "right",
            width: 110,
            renderCell: renderCellExpand,
            cellClassName: (params) => {
              return ((params.row.mf_colordescription === "" || params.row.mf_colordescription === null) &&
                (params.row.colordescription === "" || params.row.colordescription === null)) ?
                undefined :
                'yellowCell';

            }
          })
        }
        else if (columnData.field === "mf_rapnetprice") {
          columnNames.push({
            field: "rapnetprice",
            headerName: "RAP",
            headerAlign: "center",
            align: "right",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 70,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.rapnetprice),
            cellClassName: (params) => {
              return (params.row.rapnetprice === null) ? undefined : params.row.rapnetprice > params.row.mf_rapnetprice ? 'greenCell' : params.row.rapnetprice < params.row.mf_rapnetprice ? 'yellowCell' : null;
            }
          })
        }
        else if (columnData.field === "mf_price") {
          columnNames.push({
            field: "price",
            headerName: "PPC",
            headerAlign: "center",
            align: "right",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 70,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price),
            cellClassName: (params) => {
              return (params.row.price === null) ? undefined : params.row.price > params.row.mf_price ? 'greenCell' : params.row.price < params.row.mf_price ? 'yellowCell' : null;
            }
          })
        }
        else if (columnData.field === "mf_total") {
          columnNames.push({
            field: "total",
            headerName: "TOTAL",
            headerAlign: "center",
            align: "right",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 70,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.total),
            cellClassName: (params) => {
              return (params.row.total === null) ? undefined : params.row.total > params.row.mf_total ? 'greenCell' : params.row.total < params.row.mf_total ? 'yellowCell' : null;
            }
          })
        }
      }
    });
    setColumnNames(columnNames);
  }

  const handleSearchSym = () => {
    setApproveRejectListLoader(true);
    LabTestProxy.GetSymMaster((response) => {
      if (response) {
        setSymMasterMap(response);
        setApproveRejectListLoader(false);
      } else {
        setErrorSnackbar(true)
        setApproveRejectListLoader(false);
      }
    });
  };

  const handleSearchPol = () => {
    setApproveRejectListLoader(true);
    LabTestProxy.GetPolMaster((response) => {
      if (response) {
        setPolMasterMap(response);
        setApproveRejectListLoader(false);
      } else {
        setErrorSnackbar(true)
        setApproveRejectListLoader(false);
      }
    });
  };

  const handleSearchFlo = () => {
    setApproveRejectListLoader(true);
    LabTestProxy.GetFloMaster((response) => {
      if (response) {
        setFloMasterMap(response);
        setApproveRejectListLoader(false);
      } else {
        setErrorSnackbar(true)
        setApproveRejectListLoader(false);
      }
    });
  };

  const handleSearchCut = () => {
    setApproveRejectListLoader(true);
    LabTestProxy.GetCutMaster((response) => {
      if (response) {
        setCutMasterMap(response);
        setApproveRejectListLoader(false);
      } else {
        setErrorSnackbar(true)
        setApproveRejectListLoader(false);
      }
    });
  };


  const handleSearchClarity = () => {
    setApproveRejectListLoader(true);
    LabTestProxy.GetClarityMaster((response) => {
      if (response) {
        setClarityMasterMap(response);
        setApproveRejectListLoader(false);
      } else {
        setErrorSnackbar(true)
        setApproveRejectListLoader(false);
      }
    });
  };

  const handleSearchColor = () => {
    setApproveRejectListLoader(true);
    LabTestProxy.GetColorMaster((response) => {
      if (response) {
        setColorMasterMap(response);
        setApproveRejectListLoader(false);
        setFlag(true);
      } else {
        setErrorSnackbar(true)
        setApproveRejectListLoader(false);
      }
    });
  };
  const handleRejectOpen = () => {
    setShowRejectModal(!showRejectModal);
  };

  const handleValidation = (data) => {
    //TODO do validation if needed here
    return true;
  };

  const CreateAllCriteria = (criteriaList) => {
    NivodaUtilityProxy.CreateAllCriteria(criteriaList, (response) => {
      if (response) {
        setSuccessResponse(true);
        setSnackBarMessage("Criteria Created Successfully");
      }
      else {
        setLoading(false);
        setErrorSnackbar(true);
      }
    })
  }

  const handleApproveStones = (data) => {
    let criteriaList = generatePayload(data);
    setLoading(true);
    setShowApproveModal(false);
    LabTestProxy.ApproveStones(data, (responseData) => {
      if (responseData) {
        setLoading(false);
        handleSearch();
        setSuccessResponse(true);
        setSnackBarMessage("Stones Approved Successfully");
        if (criteriaList.length > 0) {
          CreateAllCriteria(criteriaList);
        }
      } else {
        setLoading(false);
        setErrorSnackbar(true);
      }
    });
  };

  const generatePayload = (data) => {
    const stoneIds = new Set(data.stones.map(stone => stone.stoneid));

    return listData
      .filter(item => stoneIds.has(item.stoneid) && item.colortype === "WHITE")
      .map(item => ({
        id: null,
        stonetype: item.stonetype,
        mystock: 0,
        color: item.color,
        clarity: item.clarity,
        certificate: item.labname,
        shapes: item.mf_shape,
        cut: item.cut,
        sym: item.sym,
        flo: item.flo,
        pol: item.pol,
        carat: item.size,
        stoneid: item.stoneid,
        status: 'NEW',
        enable: true,
        iteration: null,
        measurements: item.measurements,
        location: item.location,
        discount: parseFloat(item.discount),
        rapnet: parseFloat(item.rapnetprice),
        depth: parseFloat(item.depth),
        table: parseFloat(item.tablepercent),
        crang: parseFloat(item.crownangle),
        pct: parseFloat(item.price),
        total: parseFloat(item.total),
        filtertype: "Similar or Better",
        every: 0,
        milky: item.milky,
        tinge: item.tinge,
        priority: 1,
        treatmenttype: item.stonetype === "N" || "H" ? "" : "CVD",
      }));
  };


  const handleSelection = (data) => {
    const [tempStockData, tempSelectionModel] = Utility.handleSelection(data, listData, selectionModel);

    setListData(tempStockData);
    setSelectionModel(tempSelectionModel);
  }

  const handleRejectStones = (mix, data) => {
    setRejectLoading(true);
    setShowRejectModal(false);
    if (mix) {
      LabTestProxy.RejectStonesToMix(data, (responseData) => {
        if (responseData && responseData.status === "Success") {
          handleSearch();
          setSuccessResponse(true);
          setSnackBarMessage("Stones Rejected Successfully");
        } else {
          setRejectLoading(false);
          setErrorSnackbar(true);
        }
      });
    } else {
      LabTestProxy.RejectStones(data, (responseData) => {
        if (responseData) {
          handleSearch();
          setSuccessResponse(true);
          setSnackBarMessage("Stones Rejected Successfully");
        } else {
          setRejectLoading(false);
          setErrorSnackbar(true);
        }
      });
    }
  };

  const handleStoneDetailModal = (params) => {
    setStoneId(params.value);
    setShowStoneDetailModal(true);
  };

  const handleClose = () => {
    setShowStoneDetailModal(false);
  };

  const columnsData = {

    "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
      field: "stoneid",
      headerName: "STONEID",
      headerAlign: "center",
      width: 80,
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
        <Button
          sx={{ textDecorationLine: "underline", color: "black" }}
          onClick={() => handleStoneDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    "c6161d51-13c0-479e-abe8-2a14b2d8b914": {
      field: "resultdate",
      headerName: "RESULT DATE",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "date",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.value),
    },
    "f3223657-c8d2-449c-b2f5-5a54c78401ce": {
      field: "tableinc",
      headerName: "TABLE INC",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "f114ad2c-8560-4da7-9b03-03ba6bfe39a5": {
      field: "sideinc",
      headerName: "SIDE INC",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "e993a4f7-7c50-4d83-abae-fccc03382742": {
      field: "h_and_a",
      headerName: "H&A",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "f2fe7666-6489-40ce-b4b7-040c68c88bf3": {
      field: "eyeclean",
      headerName: "EYE CLEAN",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "b38b9fdf-bfb8-43c6-82a2-1e366fa71523": {
      field: "tinge",
      headerName: "TINGE",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.tinge.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
    },
    "c95089ee-166d-4783-817c-2638f6d40df1": {
      field: "milky",
      headerName: "MILKY",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.milky.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
    },
    "2a6475ff-481f-48c6-9e92-3ede0b97d7c0": {
      field: "luster",
      headerName: "LUSTER",
      headerAlign: "center",
      align: "center",
      width: 120,
    },
    "556ae429-3605-4df4-88d8-b5223fc2e2fb": {
      field: "tableblack",
      headerName: "TABLE BLACK",
      headerAlign: "center",
      align: "center",
      type: "boolean",
      width: 120,
    },
    "5c70d1ca-2a7b-4660-8160-0beff7ad1150": {
      field: "sideblack",
      headerName: "SIDE BLACK",
      headerAlign: "center",
      align: "center",
      type: "boolean",
      width: 120,
    },
    "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
      field: "stonetype",
      headerName: "STONETYPE",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
    },
    "9dfe5dd6-726c-465b-9f61-22fca6660b4f": {
      field: "mf_kapanid",
      headerName: "KAPAN ID",
      headerAlign: "center",
      align: "center",
      width: 80,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "8eaa8a03-d163-436d-8912-51ea06306f44": {
      field: "certificateid",
      headerName: "CERT",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
      field: "mf_size",
      headerName: "MF SIZE",
      headerAlign: "center",
      align: "right",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.mf_size),
      cellClassName: (params) => {
        return 'redCell';
      }
    },
    "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
      field: "mf_color",
      headerName: "MF COLOR",
      headerAlign: "center",
      align: "center",
      width: 90,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
      cellClassName: (params) => {
        return 'redCell';
      }
    },
    "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
      field: "mf_clarity",
      headerName: "MF CLARITY",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 95,
      renderCell: renderCellExpand,
      cellClassName: (params) => {
        return 'redCell';
      }
    },
    "3597803f-8932-40c6-8de6-81006f4d6d5b": {
      field: "mf_cut",
      headerName: "MF CUT",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 70,
      renderCell: renderCellExpand,
      cellClassName: (params) => {
        return 'redCell';
      }
    },
    "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
      field: "mf_pol",
      headerName: "MF POL",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 70,
      renderCell: renderCellExpand,
      cellClassName: (params) => {
        return 'redCell';
      }
    },
    "5541c182-21b8-496e-b342-b0b89f3d302f": {
      field: "mf_sym",
      headerName: "MF SYM",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 70,
      renderCell: renderCellExpand,
      cellClassName: (params) => {
        return 'redCell';
      }
    },
    "8296e627-0be5-4a66-830f-ea6867cea137": {
      field: "mf_flo",
      headerName: "MF FLO",
      headerAlign: "center",
      align: "center",
      width: 80,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
      cellClassName: (params) => {
        return 'redCell';
      }
    },
    "d4992de9-92ab-4f9e-ba12-6c746e935611": {
      field: "mf_colordescription",
      headerName: "MF COL DESCRIP",
      headerAlign: "center",
      align: "right",
      width: 170,
      renderCell: renderCellExpand,
      cellClassName: (params) => {
        return 'redCell';
      }
    },
    "6defca68-d5d9-4c30-ae83-938a01f45a07": {
      field: "colortype",
      headerName: "COL TYPE",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
      field: "mf_rapnetprice",
      headerName: "MF RAP",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.mf_rapnetprice),
      cellClassName: (params) => {
        return 'redCell';
      }
    },
    "798a8663-0f0c-41be-8512-16dd60d5f25e": {
      field: "discount",
      headerName: "DIS",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "right",
      width: 50,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discount),
    },
    "39c634f1-2644-4307-acbb-983b4de4229e": {
      field: "mf_price",
      headerName: "MF PPC",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.mf_price),
      cellClassName: (params) => {
        return 'redCell';
      }
    },
    "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
      field: "mf_total",
      headerName: "MF TOTAL",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.mf_total),
      cellClassName: (params) => {
        return 'redCell';
      }
    },
    "b718f242-4a82-42e7-b98a-40bbf0f67c21": {
      field: "mf_shade",
      headerName: "SHADE",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: renderCellExpand,
    },
    "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
      field: "mf_shape",
      headerName: "SHAPE",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 80,
      renderCell: renderCellExpand,
    },
    "567202e6-c31c-4c19-9998-1cacae05af6e": {
      field: "depth",
      headerName: "DEPTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "3c62ef48-9538-4df7-9484-a9ae1ba31086": {
      field: "height",
      headerName: "HEIGHT",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "eed9b7eb-17e4-4ec6-9c9d-c299f885544c": {
      field: "width",
      headerName: "WIDTH",
      headerAlign: "center",
      align: "center",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
      field: "labname",
      headerName: "LAB",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 120,
      renderCell: renderCellExpand,
    },
    "19ce7030-402c-495c-84ac-a29093bdb0ac": {
      field: "locationid",
      headerName: "LOCATION ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "ab3e506e-bddb-456d-b967-922dcee74d56": {
      field: "location",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 100,
      renderCell: renderCellExpand,
    },
    "f97a0118-3891-4f77-abf7-8636c26d594c": {
      field: "country",
      headerName: "COUNTRY",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "cb7e6add-67ba-4194-ac49-fd0d967db4e8": {
      field: "quality",
      headerName: "QUALITY",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "e7210f4a-6e0a-4591-8428-e6845004ed04": {
      field: "crownheight",
      headerName: "CR.HEIGHT",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "c4e65984-1682-4c1e-812b-8938e9078b2d": {
      field: "crownangle",
      headerName: "CR.ANG",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "0f1de38d-3ae3-4209-a4d5-afe9f3018f22": {
      field: "culetsize",
      headerName: "CULET SZ",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "e3f77521-2c57-46bc-a02b-3c884685d2be": {
      field: "culetcondition",
      headerName: "CULET",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
      field: "depthpercent",
      headerName: "DEPTH%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "cee57bac-9c19-40d5-b51a-51ed913dbf73": {
      field: "intensitylongtitle",
      headerName: "INTENSITYLONGTITLE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "06d2a589-0d42-4dde-8724-acf2448c839a": {
      field: "laserinscription",
      headerName: "INS",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
      field: "comment",
      headerName: "COMMENT",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "13d48508-b8c9-4661-8a6c-9fb22a3408a3": {
      field: "measurements",
      headerName: "MEASUREMENTS",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
    },
    "61f8a5f2-8516-419a-b6fd-39ef109cc2f4": {
      field: "paviliondepth",
      headerName: "PV.DEPTH",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
      field: "tablepercent",
      headerName: "TABLE%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "e9028170-e978-4978-a2c9-1889c1821495": {
      field: "gridlecondition",
      headerName: "GIRDLE COND",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "5aefce13-0b00-4b9a-929d-87278b39deec": {
      field: "gridlethick",
      headerName: "GIRDLE MAX",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "3a14a294-e185-4735-9336-e12d3ec9685b": {
      field: "gridlethin",
      headerName: "GIRDLE MIN",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "fe8f55f3-358a-4418-bcdf-c3da4b01db67": {
      field: "gridlepercent",
      headerName: "GIRDLE%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "daf69bba-bb1f-4d54-9dc7-9383ad429585": {
      field: "pavilionangle",
      headerName: "PV.ANGLE",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "ecfdfc0c-6a25-4a6d-9c8f-3406c23410af": {
      field: "white",
      headerName: "WHITE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "db078198-4416-4d53-b3d0-70d3a5418f65": {
      field: "mf_open",
      headerName: "OPEN",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "dd934505-1865-48cb-878f-f5d3c18af2d5": {
      field: "mf_note",
      headerName: "NOTE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "a1299782-d545-4d70-bcbc-7d576e396d64": {
      field: "length",
      headerName: "LENGTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "e683145c-29dd-4d41-af1a-518ff80090d2": {
      field: "keytosymbols",
      headerName: "KEY TO SYMBOL",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand,
    },
    "66dfbc62-477f-42f0-8097-56c5d8329156": {
      field: "lrhalf",
      headerName: "LR HALF",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand,
    },
    "dfd5488a-b600-4e75-9735-98c26f78dc84": {
      field: "strln",
      headerName: "STRLN",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand,
    },
    "cf694b75-ba5d-4a73-8fcf-e7566974c4b6": {
      field: "media",
      headerName: "MEDIA",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: (params) => (
        <Tooltip title={"Stone Media"} sx={{ cursor: "pointer" }}>
          <VideoLibraryTwoToneIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setStoneMediaURL(params.row.stonemediaurl);
              setShowStoneMediaModal(true);
            }} />
        </Tooltip>
      ),
    },

  };

  const columns = columnNames;

  const getExcelData = (response) => {

    let outerArray = [];
    let redColor = "FFF5D7D7";
    let greenColor = "FFB6D7A8";
    let yellowColor = "FFF1E68C";
    let whiteColor = "D9FFFFFF";
    let greyColor = "FFDDDDDD";

    const borderStyle = {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    };

    const headerStyle = {
      border: borderStyle,
      alignment: { horizontal: "center" },
      font: { bold: true },
      fill: { patternType: "solid", fgColor: { rgb: greyColor } }
    };

    response.map((item, index) => {
      let innerArray = [];
      innerArray.push({ value: index + 1, style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } } });
      innerArray.push({
        value: !Utility.isValueValid(item["batchid"]) ? "" : item["batchid"],
        style: { alignment: { horizontal: "center" }, border: borderStyle }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["mf_kapanid"]) ? "" : item["mf_kapanid"],
        style: { alignment: { horizontal: "center" }, border: borderStyle }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["stonetype"]) ? "" : Constants.STONE_TYPE[item["stonetype"]],
        style: { alignment: { horizontal: "center" }, border: borderStyle }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["certificateid"]) ? "" : item["certificateid"],
        style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["stoneid"]) ? "" : item["stoneid"],
        style: { alignment: { horizontal: "center" }, border: borderStyle }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["suratid"]) ? "" : item["suratid"],
        style: { alignment: { horizontal: "center" }, border: borderStyle }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["shape"]) ? "" : item["shape"],
        style: { alignment: { horizontal: "center" }, border: borderStyle }
      });

      innerArray.push({
        value: !Utility.isValueValid(item["mf_size"]) ? "" : parseFloat(item["mf_size"].toFixed(2)),
        style: { fill: { patternType: "solid", fgColor: { rgb: redColor } }, alignment: { horizontal: "right" }, border: borderStyle }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["size"]) ? "" : parseFloat(item["size"].toFixed(2)),
        style: { fill: { patternType: "solid", fgColor: { rgb: item["mf_size"] > item["size"] ? yellowColor : (item["mf_size"] < item["size"] ? greenColor : whiteColor) } }, alignment: { horizontal: "right" }, border: borderStyle }
      });

      innerArray.push({
        value: !Utility.isValueValid(item["mf_color"]) ? "" : item["mf_color"],
        style: { fill: { patternType: "solid", fgColor: { rgb: redColor } }, alignment: { horizontal: "center" }, border: borderStyle }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["color"]) ? "" : item["color"],
        style: { fill: { patternType: "solid", fgColor: { rgb: colorMasterMap[item["mf_color"]] > colorMasterMap[item["color"]] ? greenColor : (colorMasterMap[item["mf_color"]] < colorMasterMap[item["color"]] ? yellowColor : whiteColor) } }, alignment: { horizontal: "center" }, border: borderStyle }
      });

      innerArray.push({
        value: !Utility.isValueValid(item["mf_colordescription"]) ? "" : item["mf_colordescription"],
        style: { fill: { patternType: "solid", fgColor: { rgb: redColor } }, alignment: { horizontal: "center" }, border: borderStyle }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["colordescriptions"]) ? "" : item["colordescriptions"],
        style: { fill: { patternType: "solid", fgColor: { rgb: (item["mf_colordescription"] === "" || item["mf_colordescription"] === null) && (item["colordescriptions"] === "" || item["colordescriptions"] === null) ? whiteColor : yellowColor } }, alignment: { horizontal: "center" }, border: borderStyle }
      });

      innerArray.push({
        value: !Utility.isValueValid(item["mf_clarity"]) ? "" : item["mf_clarity"],
        style: { fill: { patternType: "solid", fgColor: { rgb: redColor } }, alignment: { horizontal: "center" }, border: borderStyle }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["clarity"]) ? "" : item["clarity"],
        style: { fill: { patternType: "solid", fgColor: { rgb: clarityMasterMap[item["mf_clarity"]] > clarityMasterMap[item["clarity"]] ? greenColor : (clarityMasterMap[item["mf_clarity"]] < clarityMasterMap[item["clarity"]] ? yellowColor : whiteColor) } }, alignment: { horizontal: "center" }, border: borderStyle }
      });

      innerArray.push({
        value: !Utility.isValueValid(item["mf_cut"]) ? "" : item["mf_cut"],
        style: { fill: { patternType: "solid", fgColor: { rgb: redColor } }, alignment: { horizontal: "center" }, border: borderStyle }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["cut"]) ? "" : item["cut"],
        style: { fill: { patternType: "solid", fgColor: { rgb: cutMasterMap[item["mf_cut"]] > cutMasterMap[item["cut"]] ? yellowColor : (cutMasterMap[item["mf_cut"]] < cutMasterMap[item["cut"]] ? greenColor : whiteColor) } }, alignment: { horizontal: "center" }, border: borderStyle }
      });

      innerArray.push({
        value: !Utility.isValueValid(item["mf_pol"]) ? "" : item["mf_pol"],
        style: { fill: { patternType: "solid", fgColor: { rgb: redColor } }, alignment: { horizontal: "center" }, border: borderStyle }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["pol"]) ? "" : item["pol"],
        style: { fill: { patternType: "solid", fgColor: { rgb: polMasterMap[item["mf_pol"]] > polMasterMap[item["pol"]] ? yellowColor : (polMasterMap[item["mf_pol"]] < polMasterMap[item["pol"]] ? greenColor : whiteColor) } }, alignment: { horizontal: "center" }, border: borderStyle }
      });

      innerArray.push({
        value: !Utility.isValueValid(item["mf_sym"]) ? "" : item["mf_sym"],
        style: { fill: { patternType: "solid", fgColor: { rgb: redColor } }, alignment: { horizontal: "center" }, border: borderStyle }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["sym"]) ? "" : item["sym"],
        style: { fill: { patternType: "solid", fgColor: { rgb: symMasterMap[item["mf_sym"]] > symMasterMap[item["sym"]] ? yellowColor : (symMasterMap[item["mf_sym"]] < symMasterMap[item["sym"]] ? greenColor : whiteColor) } }, alignment: { horizontal: "center" }, border: borderStyle }
      });

      innerArray.push({
        value: !Utility.isValueValid(item["mf_flo"]) ? "" : item["mf_flo"],
        style: { fill: { patternType: "solid", fgColor: { rgb: redColor } }, alignment: { horizontal: "center" }, border: borderStyle }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["flo"]) ? "" : item["flo"],
        style: { fill: { patternType: "solid", fgColor: { rgb: floMasterMap[item["mf_flo"]] > floMasterMap[item["flo"]] ? yellowColor : (floMasterMap[item["mf_flo"]] < floMasterMap[item["flo"]] ? greenColor : whiteColor) } }, alignment: { horizontal: "center" }, border: borderStyle }
      });

      innerArray.push({
        value: !Utility.isValueValid(item["mf_rapnetprice"]) ? "" : Number(item["mf_rapnetprice"]),
        style: { fill: { patternType: "solid", fgColor: { rgb: redColor } }, alignment: { horizontal: "right" }, border: borderStyle, numFmt: "0.00", }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["rapnetprice"]) ? "" : Number(item["rapnetprice"]),
        style: { fill: { patternType: "solid", fgColor: { rgb: item["mf_rapnetprice"] > item["rapnetprice"] ? yellowColor : (item["mf_rapnetprice"] < item["rapnetprice"] ? greenColor : whiteColor) } }, alignment: { horizontal: "right" }, border: borderStyle, numFmt: "0.00", }
      });

      innerArray.push({
        value: !Utility.isValueValid(item["discount"]) ? "" : Number(item["discount"]),
        style: { alignment: { horizontal: "right" }, border: borderStyle, numFmt: "0.00", }
      });

      innerArray.push({
        value: !Utility.isValueValid(item["mf_price"]) ? "" : Number(item["mf_price"]),
        style: { fill: { patternType: "solid", fgColor: { rgb: redColor } }, alignment: { horizontal: "right" }, border: borderStyle, numFmt: "0.00", }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["price"]) ? "" : Number(item["price"]),
        style: { fill: { patternType: "solid", fgColor: { rgb: item["mf_price"] > item["price"] ? yellowColor : (item["mf_price"] < item["price"] ? greenColor : whiteColor) } }, alignment: { horizontal: "right" }, border: borderStyle, numFmt: "0.00", }
      });

      innerArray.push({
        value: !Utility.isValueValid(item["mf_total"]) ? "" : Number(item["mf_total"]),
        style: { fill: { patternType: "solid", fgColor: { rgb: redColor } }, alignment: { horizontal: "right" }, border: borderStyle, numFmt: "0.00", }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["total"]) ? "" : Number(item["total"]),
        style: { fill: { patternType: "solid", fgColor: { rgb: item["mf_total"] > item["total"] ? yellowColor : (item["mf_total"] < item["total"] ? greenColor : whiteColor) } }, alignment: { horizontal: "right" }, border: borderStyle, numFmt: "0.00", }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["culetsize"]) ? "" : item["culetsize"],
        style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["culetcondition"]) ? "" : item["culetcondition"],
        style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["mf_height"]) ? "" : Number(item["mf_height"]),
        style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" }, numFmt: "0.00" }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["depth"]) ? "" : Number(item["depth"]),
        style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" }, numFmt: "0.00" }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["gridlethick"]) ? "" : item["gridlethick"],
        style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["pavilionangle"]) ? "" : item["pavilionangle"],
        style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["lrhalf"]) ? "" : item["lrhalf"],
        style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["colortype"]) ? "" : item["colortype"],
        style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["mf_comment"]) ? "" : item["mf_comment"],
        style: { alignment: { horizontal: "center", wrapText: true }, border: borderStyle, font: { sz: "10" } }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["mf_shade"]) ? "" : item["mf_shade"],
        style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["resultdate"]) ? "" : Utility.ConvertUtcToLocalDate(item["resultdate"]),
        style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } }
      });
      innerArray.push({
        value: !Utility.isValueValid(item["mf_width"]) ? "" : parseFloat(item["mf_width"]),
        style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" }, numFmt: "0.00" }
      });
      innerArray.push({ value: !Utility.isValueValid(item["measurements"]) ? "" : item["measurements"], style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } } });
      innerArray.push({ value: !Utility.isValueValid(item["depthpercent"]) ? "" : Number(item["depthpercent"]), style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } } });
      innerArray.push({ value: !Utility.isValueValid(item["tablepercent"]) ? "" : Number(item["tablepercent"]), style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } } });
      innerArray.push({ value: !Utility.isValueValid(item["keytosymbols"]) ? "" : item["keytosymbols"], style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } } });
      innerArray.push({ value: !Utility.isValueValid(item["comment"]) ? "" : item["comment"], style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } } });
      innerArray.push({ value: !Utility.isValueValid(item["fancycolor1"]) ? "" : item["fancycolor1"], style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } } });
      innerArray.push({ value: !Utility.isValueValid(item["length"]) ? "" : Number(item["length"]), style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } } });
      innerArray.push({ value: !Utility.isValueValid(item["tinge"]) ? "" : item["tinge"], style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } } });
      innerArray.push({ value: !Utility.isValueValid(item["crownangle"]) ? "" : item["crownangle"], style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } } });
      innerArray.push({ value: !Utility.isValueValid(item["milky"]) ? "" : item["milky"], style: { alignment: { horizontal: "center" }, border: borderStyle, font: { sz: "10" } } });
      outerArray.push(innerArray);

      return true;
    });

    let excelData = [
      {
        columns: [
          { title: "ID", width: { wpx: 80 }, style: headerStyle },
          { title: "BATCH ID", width: { wpx: 80 }, style: headerStyle },
          { title: "Kapan Id", width: { wpx: 80 }, style: headerStyle },
          { title: "Stone Type", width: { wpx: 80 }, style: headerStyle },
          { title: "Certificate Id", width: { wpx: 120 }, style: headerStyle },
          { title: "Stone Id", width: { wpx: 80 }, style: headerStyle },
          { title: "Surat Id", width: { wpx: 80 }, style: headerStyle },
          { title: "Shape", width: { wpx: 80 }, style: headerStyle },
          { title: "MF CTS", width: { wpx: 70 }, style: headerStyle },
          { title: "CTS", width: { wpx: 40 }, style: headerStyle },
          { title: "MF COL", width: { wpx: 70 }, style: headerStyle },
          { title: "COL", width: { wpx: 40 }, style: headerStyle },
          { title: "MF COL DESC", width: { wpx: 100 }, style: headerStyle },
          { title: "COL DESC", width: { wpx: 80 }, style: headerStyle },
          { title: "MF CLR", width: { wpx: 70 }, style: headerStyle },
          { title: "CLR", width: { wpx: 40 }, style: headerStyle },
          { title: "MF CUT", width: { wpx: 70 }, style: headerStyle },
          { title: "CUT", width: { wpx: 40 }, style: headerStyle },
          { title: "MF POL", width: { wpx: 70 }, style: headerStyle },
          { title: "POL", width: { wpx: 40 }, style: headerStyle },
          { title: "MF SYM", width: { wpx: 70 }, style: headerStyle },
          { title: "SYM", width: { wpx: 40 }, style: headerStyle },
          { title: "MF FLOR", width: { wpx: 70 }, style: headerStyle },
          { title: "FLOR", width: { wpx: 40 }, style: headerStyle },
          { title: "MF RAP", width: { wpx: 80 }, style: headerStyle },
          { title: "RAP", width: { wpx: 80 }, style: headerStyle },
          { title: "DIS", width: { wpx: 50 }, style: headerStyle },
          { title: "MF P/CT", width: { wpx: 80 }, style: headerStyle },
          { title: "P/CT", width: { wpx: 80 }, style: headerStyle },
          { title: "MF Total", width: { wpx: 80 }, style: headerStyle },
          { title: "Total", width: { wpx: 80 }, style: headerStyle },
          { title: "CULET SZ", width: { wpx: 120 }, style: headerStyle },
          { title: "CULET COND", width: { wpx: 120 }, style: headerStyle },
          { title: "Height", width: { wpx: 60 }, style: headerStyle },
          { title: "Depth", width: { wpx: 60 }, style: headerStyle },
          { title: "GIRDLE MAX", width: { wpx: 100 }, style: headerStyle },
          { title: "PV.ANGLE", width: { wpx: 100 }, style: headerStyle },
          { title: "LR HALF", width: { wpx: 100 }, style: headerStyle },
          { title: "Color Type", width: { wpx: 80 }, style: headerStyle },
          { title: "MF Comment", width: { wpx: 60 }, style: headerStyle },
          { title: "Shade", width: { wpx: 60 }, style: headerStyle },
          { title: "Result Date", width: { wpx: 160 }, style: headerStyle },
          { title: "Width", width: { wpx: 60 }, style: headerStyle },
          { title: "MEASUREMENTS", width: { wpx: 120 }, style: headerStyle },
          { title: "DEPTH%", width: { wpx: 70 }, style: headerStyle },
          { title: "TABLE%", width: { wpx: 70 }, style: headerStyle },
          { title: "KEY TO SYMBOLS", width: { wpx: 120 }, style: headerStyle },
          { title: "COMMENT", width: { wpx: 200 }, style: headerStyle },
          { title: "F.COLOR", width: { wpx: 80 }, style: headerStyle },
          { title: "LENGTH", width: { wpx: 120 }, style: headerStyle },
          { title: "TINGE", width: { wpx: 120 }, style: headerStyle },
          { title: "CR.ANG", width: { wpx: 70 }, style: headerStyle },
          { title: "MILKY", width: { wpx: 120 }, style: headerStyle },
        ],
        data: outerArray
      }
    ];

    return excelData;
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          alignItems: "center",
          marginHorizontal: "5px",
          "&.MuiDataGrid-toolbarContainer": {
            padding: "0px 4px !important",
          },
        }}
      >
        <CommonStoneSelection
          title={"Enter multiple Stone Ids"}
          handleSelection={handleSelection}
          buttonDisabled={listData.length === 0}
        />

        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport />
        <Box sx={{ flexGrow: 1, display: { md: "none", lg: "block" } }} />
        {approveRejectListLoader ? (
          <CircularProgress size="1rem" />
        ) : (
          <Tooltip title="Reload List">
            <RefreshOutlinedIcon
              onClick={() => handleSearch()}
              color="primary"
              fontSize="medium"
              sx={{ cursor: "pointer" }}
            />
          </Tooltip>
        )}
        <ExportToExcel
          sourceData={fullExcelData}
        />
        {Utility.isUpdateAllowed(local_Permission) ? (
          <Tooltip title="Approve Stones">
            <LoadingButton
              component="label"
              variant="outlined"
              size="small"
              sx={{ ml: "5px" }}
              startIcon={<ThumbUpAltIcon size="large" />}
              disabled={selectionModel.length < 1 || rejectLoading}
              onClick={() => {
                setShowApproveModal(true);
                setType("approve");
              }}
              loading={loading}
              loadingPosition="start"
              type="submit"
            >
              Approve
            </LoadingButton>
          </Tooltip>
        ) : null}

        {showApproveModal && (
          <ApproveModal
            show={showApproveModal}
            setShow={setShowApproveModal}
            handleValidation={handleValidation}
            handleSave={handleApproveStones}
            stoneId={selectionModel}
            sourceData={listData}
            type={type}
          />
        )}

        {Utility.isUpdateAllowed(local_Permission) ? (
          <Tooltip title="Reject Stones">
            <LoadingButton
              component="label"
              variant="outlined"
              size="small"
              color="error"
              sx={{ ml: "5px" }}
              startIcon={<ThumbDownAltIcon size="large" />}
              disabled={selectionModel.length < 1 || loading}
              onClick={() => {
                handleRejectOpen();
                setType("REJECT");
              }}
              loading={rejectLoading}
              loadingPosition="start"
              type="submit"
            >
              Reject
            </LoadingButton>
          </Tooltip>
        ) : null}
        <GridToolbarQuickFilter debounceMs={500} />
      </GridToolbarContainer>
    )
  }

  return (
    <div>
      {showStoneDetailModal ? (
        <StoneDetailModal
          show={showStoneDetailModal}
          stoneId={stoneId}
          handleClose={handleClose}
        />
      ) : null}

      {showStoneMediaModal ? (
        <>
          <StoneMediaModal
            show={showStoneMediaModal}
            stoneMediaURL={stoneMediaURL}
            handleClose={() => setShowStoneMediaModal(false)}
          />
        </>
      ) : null}

      <TabMenuSnackbar
        show={errorSnackbar}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Error"}
        handleClose={() => setErrorSnackbar(false)}
      />
      {successResponse ? (
        <TabMenuSnackbar
          show={successResponse}
          message={snackBarMessage}
          variant={"success"}
          autoHide={true}
          title={"Success"}
          handleClose={() => setSuccessResponse(false)}
        />
      ) : null}

      {showRejectModal && (
        <MixStoneBucketModal
          show={showRejectModal}
          setShow={setShowRejectModal}
          handleSave={handleRejectStones}
          stoneId={selectionModel}
          sourceData={listData}
          rejectComponent={true}
        />
      )}
      <Box display={"flex"} margin={"4px 8px"} justifyContent='space-between' marginTop={"1px"}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            flexGrow: 1,
            flexBasis: 0,
            overflow: "hidden",
            color: "black",
            fontWeight: "normal",
            px: 1,
            textAlign: "center",
            paddingTop: "10px",
            paddingBottom: "21px",
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            useFlexGap
            flexWrap="wrap"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              justifyContent: "flex-start",
            }}
          >
            <Typography
              component="span"
              sx={{ fontSize: Constants.defaultTableFontSize }}
            >
              No of Stones: <b>{noOfSelectedStones}</b>
            </Typography>
            <Typography
              component="span"
              sx={{ fontSize: Constants.defaultTableFontSize }}
            >
              Total Weight: <b>{selectedTotalSize}</b>
            </Typography>
            <Typography
              component="span"
              sx={{ fontSize: Constants.defaultTableFontSize }}
            >
              Total Price: <b>{selectedtotalPrice}</b>
            </Typography>
            <Typography
              component="span"
              sx={{ fontSize: Constants.defaultTableFontSize }}
            >
              Avg Price: <b>{selectedavgPrice}</b>
            </Typography>
            <Typography
              component="span"
              sx={{ fontSize: Constants.defaultTableFontSize }}
            >
              Avg Discount: <b>{selectedAvgDiscount}</b>
            </Typography>
          </Stack>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: '#fff',
          color: '#000',
          width: "100%",
          position: "relative",
          "& .MuiTablePagination-selectLabel": {
            marginTop: "15px",
          },
          "& .MuiTablePagination-displayedRows": {
            marginTop: "15px",
          },
          "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
            fontWeight: Constants.defaultFontWeight,
          },
          "& .css-cc8tf1": {
            fontWeight: Constants.defaultFontWeight,
          },
          "& .redCell": {
            color: "#080808",
            backgroundColor: "#f5d7d7",
          },
          "& .greenCell": {
            color: "#080808",
            backgroundColor: "#B6D7A8"
          },
          "& .yellowCell": {
            color: "#080808",
            backgroundColor: "#F1E68C",
          },
          height: "70vh",
        }}
      >
        <DataGridPro
          disableRowSelectionOnClick={true}
          sx={{
            '& .MuiDataGrid-columnHeader': {
              color: '#fff',
              backgroundColor: 'grey',
            },
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
              py: "4px",
            },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
              py: "12px",
            },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
              py: "18px",
            },

            fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
          }}
          density="compact"
          loading={approveRejectListLoader}
          slots={{ toolbar: CustomToolbar }}
          rows={listData}
          columns={columns}
          getRowId={(row) => row.stoneid}

          checkboxSelection={true}
          onRowSelectionModelChange={(newSelectionModel) => {
            setSelectionModel(newSelectionModel);
          }}
          rowSelectionModel={selectionModel}
          initialState={{
            columns: {
              columnVisibilityModel: {
                // Hide columns id, the other columns will remain visible
                approved: false,
                rejected: false,
                locationid: false,
                cutpolsym: false,
                measurements: false,
                white: false,
                laserinscription: false,
                country: false,
                status: false,
                labname: false,
                location: false,
                stonelabdetailstatus: false,
                nextstate: false,
                remark: false,
                mf_note: false,
                suratid: false,
                mf_shade: false,
                quality: false,
                intensitylongtitle: false,
              },
            },
            sorting: {
              sortModel: [{ field: "stoneid", sort: "asc" }],
            },
            pagination: {
              paginationModel: Constants.pageSize,
            },
          }}
          pageSizeOptions={Constants.pageSizeOptions}
          pagination
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
        />
      </Box>
    </div>
  );
};

export default LabApproveReject;